import { takeLatest } from 'redux-saga/effects';

function* userSetActiveCompanyAsync(action) {}

export default function* userSagas() {
    yield takeLatest('auth/user/updateActiveCompany', userSetActiveCompanyAsync);
}
